export const UPDATE_LIST = 'UPDATE_LIST';

export const MARK_AS_UPDATED_LIST = 'MARK_AS_UPDATED_LIST';
